<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div
    class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
    id="page-login"
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col hidden lg:block lg:w-1/2">
              <img
                src="@/assets/images/pages/logo.png"
                alt="login"
                class="mx-auto login-img"
              />
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container">
                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">Login</h4>
                  <p>Welcome back to Showroom Portal, please login to your account.</p>
                </div>

                <div>
                  <vs-input
                    type="text"
                    v-validate="'required'"
                    data-vv-validate-on="blur"
                    label-placeholder="Suffix"
                    name="suffix"
                    placeholder="Suffix"
                    v-model="suffix"
                    class="w-full force-upper" />
                  <span class="text-danger text-sm">{{ errors.first('suffix') }}</span>

                  <vs-input
                    data-vv-validate-on="blur"
                    v-validate="'required|min:6|max:10'"
                    type="password"
                    name="password"
                    icon-no-border
                    icon="icon icon-lock"
                    icon-pack="feather"
                    label-placeholder="Password"
                    v-model="password"
                    @keydown.enter.prevent="loginUser"
                    class="w-full mt-6" />
                  <span class="text-danger text-sm">{{ errors.first('password') }}</span>
                  <div class="flex flex-wrap justify-between my-5">
                    <vs-checkbox v-model="checkbox_remember_me" class="mb-3">Remember Me</vs-checkbox>
                    <!--<router-link to="/pages/forgot-password">Forgot Password?</router-link>-->
                  </div>
                  <div class="flex flex-wrap justify-between mb-3">
                    <!--<vs-button  type="border" @click="registerUser">Register</vs-button>-->
                    <vs-button :disabled="!validateForm" @click="loginUser"  id="button-with-loading" class="vs-con-loading__container" color="rgb(0 121 193)"  type="relief">Login</vs-button>
                  </div>
                  <!--<div class="flex flex-wrap justify-between mb-3">
                    <span v-if="error">Invalid User !</span>
                  </div>-->
                  <!--<div class="flex flex-wrap justify-between my-5">
                    <vs-checkbox v-model="checkbox_remember_me" class="mb-3">Remember Me</vs-checkbox>
                    <router-link to="/pages/forgot-password">Forgot Password?</router-link>
                  </div>
                  <vs-button  type="border" @click="registerUser">Register</vs-button>
                  <vs-button class="float-right" @click="loginUser">Login</vs-button>-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
  import login from "../../graphql/Login.gql"
  import { onLogin } from '../../vue-apollo'
  export default {
    data () {
      return {
        suffix: '',
        password: '',
        checkbox_remember_me: false,
        msg:'',
        loading: false,
        colorLoading:'#fff',
        error: false
      }
    },

  computed: {
    validateForm () {
      return !this.errors.any() && this.suffix !== '' && this.password !== ''
    }
  },
  methods: {
    async loginUser(){
      this.loading = true;
      this.$vs.loading({
        color: this.colorLoading,
        container: "#button-with-loading",
        scale: 0.45
      })
      await this.$apollo.mutate({
        mutation: login,
        variables: {
          suffix: this.suffix.toUpperCase(),
          password: this.password,
        },
      }).then((data) => {
        console.log("Login", data);
        if (data.data == null) {
          this.msg = 'Invalid User'
          function getRandomInt(min, max) {
            return Math.floor(Math.random() * (max - min)) + min;
          }
          let color = `rgb(${getRandomInt(0,255)},${getRandomInt(0,255)},${getRandomInt(0,255)})`
          this.$vs.notify({
            title: 'Error!',
            text: 'Please Enter Registered Mobile No or Password !',
            color: "danger",
            position: 'top-right'
          })
        }else {
          this.$store.dispatch('userToken', data.data.login.api_token)
            //localStorage.setItem("apollo-token", data.data.login);
          onLogin(this.$apollo.provider.defaultClient, data.data.login.api_token);
            this.$router.push('/applicantDashboard').catch(() => {});
            function getRandomInt(min, max) {
              return Math.floor(Math.random() * (max - min)) + min;
            }
            let color = `rgb(${getRandomInt(0,255)},${getRandomInt(0,255)},${getRandomInt(0,255)})`
            this.$vs.notify({
              title: 'Log In',
              text: 'Logged in Successfully.',
              color: "success",
              position: 'top-right'
            })
        }
        this.$vs.loading.close("#button-with-loading > .con-vs-loading")
        this.loading = false;
      }).catch((error) => {
        this.loading = false;
        this.$vs.loading.close("#button-with-loading > .con-vs-loading")
        console.log("Error :", error )
        this.error = true;
        this.$vs.notify({
          title: 'Error!',
          text: 'Please Enter valid Username and Password.',
          color: "danger",
          position: 'top-right'
        })
      })
    },
    registerUser () {
      this.$router.push('/pages/register').catch(() => {})
    },
  }
}


</script>

<style lang="scss">
#page-login {
  .social-login-buttons {
    .bg-facebook {
      background-color: #1551b1;
    }
    .bg-twitter {
      background-color: #00aaff;
    }
    .bg-google {
      background-color: #4285f4;
    }
    .bg-github {
      background-color: #333;
    }
  }

}
.force-upper input {
  text-transform: uppercase;
}
img.mx-auto.login-img {
  /*width: 100%;*/
}

</style>
